import type { RenewScreen } from "./flow/types";
import { RenewConfirmationScreen } from "./RenewConfirmationScreen";
import { RenewIntroScreen } from "./RenewIntroScreen";
import { RenewRate } from "./RenewRate";
import { RenewRoute } from "./routes";

export const renewScreens: RenewScreen[] = [
  {
    path: RenewRoute.Intro,
    component: RenewIntroScreen,
  },
  {
    path: RenewRoute.ConfirmRate,
    component: RenewRate,
    expanded: true,
  },
  {
    path: RenewRoute.Success,
    component: RenewConfirmationScreen,
  },
];
